<script setup lang="ts">
import { type Props } from './types';

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false,
  text: '',
  inheritAttrs: false,
});

const emit = defineEmits(['update:modelValue']);

const toggle = (e: Event) => {
  if (!props.disabled) {
    const target = e.target as HTMLInputElement;
    emit('update:modelValue', target.checked);
  }
};
</script>

<template>
  <div :class="['toggler', { _disabled: disabled }]">
    <label class="toggler__label">
      <input
        v-bind="$attrs"
        type="checkbox"
        :checked="modelValue"
        class="toggler__input"
        :disabled="disabled"
        @input="toggle"
      />
      <span v-if="text" class="toggler__text">{{ text }}</span>
      <div class="toggler__switch"></div>
    </label>
  </div>
</template>

<style lang="less">
.toggler {
  &__label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: @size-x4;
    cursor: pointer;
  }

  &__input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .toggler__text + .toggler__switch,
    &:checked + .toggler__switch {
      background-color: @color-tango;

      &:before {
        transform: translateX(18px);
      }
    }

    &:disabled + .toggler__text + .toggler__switch,
    &:disabled + .toggler__switch {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &__text {
    font-size: @size-x4;
    font-weight: 500;
    line-height: 130%;
  }

  &__switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 26px;
    background-color: @color-alto;
    border-radius: 70px;
    transition: all 0.3s;

    &:before {
      content: '';
      position: absolute;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-color: white;
      top: 2px;
      left: 2px;
      transition: transform 0.3s;
    }
  }

  &._disabled {
    .toggler__label {
      cursor: not-allowed;
    }

    .toggler__switch {
      opacity: 0.5;
    }
  }
}
</style>
